import React, { Component } from "react";

import PlaidLinkButton from "./PlaidLinkButton";

import { PLAID_WEBHOOK_URL } from "../config/Api";

import { addBank, organizationUpdated } from "../actions/organization";

import { connect } from "react-redux";

class PlaidLinkConnector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      handler: null,
      loading: false
    };
  }

  handleSuccess = (publicToken, metadata) => {
    const public_token = publicToken;
    const bank_id = metadata.institution.institution_id;
    const bank_name = metadata.institution.name;
    const accounts = metadata.accounts;
    this.setState({
      loading: true
    });
    addBank(public_token, bank_id, bank_name, accounts)
      .then(newOrg => {
        this.props.organizationUpdated(newOrg);
        this.setState({
          handler: null
        });
      })
      .finally(() => {
        this.setState({
          loading: false
        });
      });
  };

  handleExit = (err, metadata) => {
    if (!err) {
      this.setState({
        handler: false,
        loading: false
      });
    }
  };

  handleOpen = Plaid => {
    const webhookURL = PLAID_WEBHOOK_URL();
    const options = {
      clientName: webhookURL ? "Spout" : "Spout (No Webhook)",
      env: process.env.PLAID_ENVIRONMENT,
      key: process.env.PLAID_PUBLIC_KEY,
      product: ["transactions"],
      onSuccess: this.handleSuccess,
      onExit: this.handleExit
    };
    if (webhookURL) {
      options.webhook = webhookURL;
    }
    const handler = Plaid.create(options);
    this.setState({
      handler
    });
    handler.open();
  };

  render() {
    return (
      <PlaidLinkButton
        message={this.props.message}
        handleOpen={this.handleOpen}
        disabled={!!this.state.handler}
        loading={this.state.loading}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  organizationUpdated: newOrg => dispatch(organizationUpdated(newOrg))
});

export default connect(
  null,
  mapDispatchToProps
)(PlaidLinkConnector);



// WEBPACK FOOTER //
// ./frontend/src/components/PlaidLinkConnector.js